// extracted by mini-css-extract-plugin
module.exports =  {"badge-value__children":"BadgeValue-module__badge-value__children___FIMab"};